<template>
  <div :class="{ 'mt-30-px': !showNavbar }">
    <notifications></notifications>
    <navbar v-if="showNavbar" :docsName="docsName" />

    <ValidationObserver v-slot="{ invalid }">
      <div class="container-fluid row">
        <div v-if="showNavbar" class="col-xl-12">
          <div class="row">
            <div class="col-xl-12 block br-t-l-0 mb-3">
              <head-menu
                :col="12"
                class="d-xl-flex"
                :headline="navbarTitel"
              ></head-menu>
              <div class="row mt-2 d-flex justify-content-between">
                <div class="ml-4">
                  <button
                    v-shortkey.once="['ctrl', 's']"
                    class="btn btn-success mr-2"
                    :disabled="invalid"
                    @click="speichern"
                    @shortkey="speichern"
                  >
                    {{ $t('global.save') }}
                  </button>
                  <button class="btn btn-primary mr-2" @click="abbrechen">
                    <font-awesome-icon icon="fa-solid fa-list" class="mr-2" />
                    {{ $t('global.tolist') }}
                  </button>
                </div>
                <div class="mr-4">
                  <button
                    v-if="berechtigungen.m_umfragen.delete && editable"
                    class="btn btn-danger"
                    @click="oeffneLoeschenModal"
                  >
                    <font-awesome-icon icon="fa-duotone fa-trash" />
                    <span>{{ $t('global.delete') }}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xl-12 pr-3">
          <container-headline
            :headline="$t('global.masterdata')"
            :col="2"
          ></container-headline>
          <div class="row mb-3">
            <div class="col-xl-12 block br-t-l-0">
              <div class="eingabe-panel-kopf p-3">

                <!-- Bezeichnung -->
                <div class="row">
                  <div class="col-xl-6">
                    <div class="form-group">
                      <ValidationProvider rules="required" immediate v-slot="{ passed }">
                        <input
                          v-model="regelsatz.bezeichnung"
                          v-bind:class="{ 'border-danger': !passed }"
                          class="form-control"
                          :readonly="!editable"
                        />
                        <label v-bind:class="{ 'text-danger': !passed }">
                          {{ $t('global.designation') }}
                        </label>
                      </ValidationProvider>
                    </div>
                  </div>
                  <div class="col-xl-6 d-flex align-items-center">
                    <div class="form-group mb-0">
                      <b-form-checkbox v-model="regelsatz.standard" :disabled="!editable">
                        Standard (als Default für neue Ausbildungspläne verfügbar)
                      </b-form-checkbox>
                    </div>
                  </div>
                </div>

                <!-- 7 Regeln -->
                <div class="row mt-3">
                  <div class="col-xl-12">
                    <h6 class="text-muted mb-3">Verknüpfte Regeln</h6>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-4">
                    <div class="form-group">
                      <v-select
                        v-model="regelsatz.notenpromotionRegel"
                        class="w-100"
                        label="bezeichnung"
                        :options="regelnOptionen"
                        :disabled="!editable"
                      >
                        <span slot="no-options">{{ $t('global.taptosearch') }}</span>
                      </v-select>
                      <label>Notenpromotion Regel</label>
                    </div>
                  </div>
                  <div class="col-xl-4">
                    <div class="form-group">
                      <v-select
                        v-model="regelsatz.promotionsblockRegel"
                        class="w-100"
                        label="bezeichnung"
                        :options="regelnOptionen"
                        :disabled="!editable"
                      >
                        <span slot="no-options">{{ $t('global.taptosearch') }}</span>
                      </v-select>
                      <label>Promotionsblock Regel</label>
                    </div>
                  </div>
                  <div class="col-xl-4">
                    <div class="form-group">
                      <v-select
                        v-model="regelsatz.promotionsgruppeRegel"
                        class="w-100"
                        label="bezeichnung"
                        :options="regelnOptionen"
                        :disabled="!editable"
                      >
                        <span slot="no-options">{{ $t('global.taptosearch') }}</span>
                      </v-select>
                      <label>Promotionsgruppe Regel</label>
                    </div>
                  </div>
                  <div class="col-xl-4">
                    <div class="form-group">
                      <v-select
                        v-model="regelsatz.sektionsgruppeRegel"
                        class="w-100"
                        label="bezeichnung"
                        :options="regelnOptionen"
                        :disabled="!editable"
                      >
                        <span slot="no-options">{{ $t('global.taptosearch') }}</span>
                      </v-select>
                      <label>Sektionsgruppe Regel</label>
                    </div>
                  </div>
                  <div class="col-xl-4">
                    <div class="form-group">
                      <v-select
                        v-model="regelsatz.sektionsRegel"
                        class="w-100"
                        label="bezeichnung"
                        :options="regelnOptionen"
                        :disabled="!editable"
                      >
                        <span slot="no-options">{{ $t('global.taptosearch') }}</span>
                      </v-select>
                      <label>Sektions Regel</label>
                    </div>
                  </div>
                  <div class="col-xl-4">
                    <div class="form-group">
                      <v-select
                        v-model="regelsatz.sektionsfeldRegel"
                        class="w-100"
                        label="bezeichnung"
                        :options="regelnOptionen"
                        :disabled="!editable"
                      >
                        <span slot="no-options">{{ $t('global.taptosearch') }}</span>
                      </v-select>
                      <label>Sektionsfeld Regel</label>
                    </div>
                  </div>
                  <div class="col-xl-4">
                    <div class="form-group">
                      <v-select
                        v-model="regelsatz.noteneingabeRegel"
                        class="w-100"
                        label="bezeichnung"
                        :options="regelnOptionen"
                        :disabled="!editable"
                      >
                        <span slot="no-options">{{ $t('global.taptosearch') }}</span>
                      </v-select>
                      <label>Noteneingabe Regel</label>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

      <unsaved-changes-modal
        @discard="handleDiscard"
        @stay="handleStay"
        :saveFunction="invalid == true ? null : speichern"
      />
    </ValidationObserver>

    <loading-overlay v-show="loading"></loading-overlay>

    <loeschen-modal
      id="regelsatz-loeschen-modal"
      @confirmed="regelsatzLoeschen"
    />
  </div>
</template>

<script>
  import HeadMenu from '@/components/HeadMenu'
  import ContainerHeadline from '@/components/ContainerHeadline'
  import Navbar from '@/components/Navbar'
  import { apiErrorToAlert } from '@/utils/Errorhandler'
  import AppApi from '@/api/AppApi'
  import store from '@/store'
  import page from '@/mixins/Page'
  import ChangeWatcherNew from '@/mixins/ChangewatcherNew'
  import UnsavedChangesModal from '@/components/Modals/UnsavedChangesModal.vue'
  import LoeschenModal from '@/components/Modals/LoeschenModal'

  export default {
    name: 'regelsatz',
    components: {
      HeadMenu,
      Navbar,
      ContainerHeadline,
      LoeschenModal,
      UnsavedChangesModal,
    },
    mixins: [page, ChangeWatcherNew],
    store,
    props: {
      id: { type: String, default: null },
      anzeige: { type: Number, default: 0 },
    },
    data() {
      return {
        editable: true,
        regelsatz: {
          id: null,
          bezeichnung: null,
          standard: false,
          notenpromotionRegel: null,
          promotionsblockRegel: null,
          promotionsgruppeRegel: null,
          sektionsgruppeRegel: null,
          sektionsRegel: null,
          sektionsfeldRegel: null,
          noteneingabeRegel: null,
        },
        regelnOptionen: [],
      }
    },
    computed: {
      navbarTitel() {
        return this.id ? 'Regelsatz' : 'Neuer Regelsatz'
      },
    },
    created() {
      this.loading = true
      Promise.all([
        this.loadRegeln(),
        this.id ? this.loadRegelsatz() : Promise.resolve(),
      ]).finally(() => {
        this.loading = false
      })
    },
    methods: {
      async loadRegeln() {
        const resp = await AppApi.get('liste-regel/', {
          params: { count: 1000 },
        })
        this.regelnOptionen = resp.data || []
      },

      async loadRegelsatz() {
        const resp = await AppApi.get('regelsatz/', { params: { id: this.id } })
        this.regelsatz = resp.data
      },

      abbrechen() {
        this.$router.push({ name: 'einstellungen-regelsaetzliste' })
      },

      async speichern() {
        if (this.loading) return
        this.loading = true
        try {
          const resp = this.id
            ? await AppApi.put('regelsatz/', this.regelsatz)
            : await AppApi.post('regelsatz/', this.regelsatz)

          this.regelsatz = resp.data
          this.$notify({
            type: 'success',
            title: this.$t('global.actionsuccessful'),
            text: 'Regelsatz erfolgreich gespeichert.',
          })
          if (!this.id) {
            this.$router.replace({
              name: 'einstellungen-regelsatz',
              params: { id: resp.data.id, anzeige: 0 },
            })
          }
        } catch (e) {
          this.$notify(apiErrorToAlert(e))
        } finally {
          this.loading = false
        }
      },

      oeffneLoeschenModal() {
        this.$bus.$emit('openLoeschenModal', 'regelsatz-loeschen-modal')
      },

      regelsatzLoeschen() {
        AppApi.delete('regelsatz/', { data: [this.id] })
          .then(() => {
            this.$router.push({ name: 'einstellungen-regelsaetzliste' })
          })
          .catch(() => {
            this.$notify({
              type: 'warn',
              title: this.$t('global.actionfailed'),
              text: 'Regelsatz konnte nicht gelöscht werden.',
            })
          })
      },
    },
  }
</script>

<style></style>
